import { render, staticRenderFns } from "./TabTote.vue?vue&type=template&id=7112aec8&scoped=true"
import script from "./TabTote.vue?vue&type=script&lang=js"
export * from "./TabTote.vue?vue&type=script&lang=js"
import style0 from "./TabTote.vue?vue&type=style&index=0&id=7112aec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7112aec8",
  null
  
)

export default component.exports